<template>
  <ul class="m-edition-map-chart-item-right-submenu">
    <li :class="[submenuItem === 0 ? 'item-active' : 'item-inactive', 'item-left']">
      <a @click.prevent="changeRightSubMolecule(0)">
        <i class="fas fa-map"></i>
        <span>{{ $t('mEditionMapChartItemRightSubMenu.items.node') }}</span>
      </a>
    </li>
    <li :class="[submenuItem === 2 ? 'item-active' : 'item-inactive', 'item-middle']">
      <a @click.prevent="changeRightSubMolecule(2)">
        <i class="fas fa-comment"></i>
        <span>{{ $t('mEditionMapChartItemRightSubMenu.items.messages') }}</span>
      </a>
    </li>
    <li :class="[submenuItem === 1 ? 'item-active' : 'item-inactive', 'item-right']">
      <a @click.prevent="changeRightSubMolecule(1)">
        <i class="fas fa-star"></i>
        <span>{{ $t('mEditionMapChartItemRightSubMenu.items.points') }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartSubMenu',

  props: {
    submenuItem: {
      type: Number,
      default: 0
    }
  },

  methods: {
    changeRightSubMolecule (item) {
      this.$emit('changeRightSubMolecule', item)
    }
  }
}
</script>
